<template>
    <div class="p-6">
        <div class="my-2" :class="showSuccess ? 'bg-teal-100 font-bold' : ''">
            <UiComponentTypography v-if="replyTo" variant="body" class-name="text-center mb-4">
                پاسخ به {{ replyTo.title ?? replyTo.name }}
            </UiComponentTypography>
            <UiComponentTypography variant="subtitle" class-name="text-center">
                <span v-if="!showSuccess">
                    دیدگاه خود را وارد کنید (نشانی ایمیل یا شماره همراه شما منتشر نخواهد شد)
                </span>
                <span v-else class="text-teal-600 p-4 flex items-center gap-2 rounded-md">
                    <UIcon name="i-solar-check-circle-line-duotone" class="w-6 h-6" />
                    دیدگاه شما با موفقیت ثبت شد، و پس از تایید در سایت نمایش داده خواهد شد.
                </span>
            </UiComponentTypography>
        </div>
        <UForm class="p-4" :schema="schema" :state="state" @submit="onSubmit">
            <UtilsFormBuilder form-size="xs" class="flex-wrap" :data="form" v-model="state">
                <template #range-2="{ data, value }">
                    <ul class="flex justify-between px-2">
                        <li v-for="i in 9" class="h-1 w-px bg-gray-400 odd:h-2"></li>
                    </ul>
                    <UiComponentTypography variant="subtitle" class-name="text-left mt-2">
                        {{ value }} از 5
                    </UiComponentTypography>
                </template>
            </UtilsFormBuilder>
            <div class="flex justify-between mt-6">
                <UButton variant="outline" :loading="loading" @click="emits('close')">
                    <span>بستن</span>
                </UButton>
                <UButton type="submit" :loading="loading">
                    <span>ثبت نظر</span>
                </UButton>
            </div>
        </UForm>
    </div>
</template>

<script lang="ts" setup>
import type { IDynamicKey, IForm } from "~/libs/types/general";
import { object, string, type InferType } from "yup";
import type { FormSubmitEvent } from "#ui/types";
import type { IUser } from "~/libs/types/api/user";
import Comment from "~/libs/schemas/forms/comment.json";
import type { IComment } from "~/libs/types/api/comments";
import type { IResponse } from "~/libs/types/api/pagination";

const emits = defineEmits(["close"]);

const props = defineProps({
    replyTo: Object as PropType<IComment>,
});

const user = useSanctumUser<IResponse<IUser>>();
const toast = useToast();
const route = useRoute();

const siteKey = process.env.CLOUDFLARE_SITE_KEY;

const form: Ref<IForm<any>[]> = ref(Comment as IForm<any>[]);

const loading = shallowRef(false);
const showSuccess = shallowRef(false);
const state: IDynamicKey<string | number | undefined> = reactive({
    guest_email: undefined,
    guest_name: undefined,
    content: undefined,
    title: undefined,
    score: 5,
});

onMounted(() => {
    if (user.value?.data.phone) state.guest_email = user.value.data.phone;
    else if (user.value?.data.email) state.guest_email = user.value.data.email;
    if (user.value?.data.name) state.guest_name = user.value.data.name;
});

const schema = object({
    guest_name: string().required("وارد کردن این فیلد الزامی‌ست"),
    guest_email: string().required("وارد کردن این فیلد الزامی‌ست"),
    content: string().required("وارد کردن این فیلد الزامی‌ست"),
});

type Schema = InferType<typeof schema>;

function errorSubmit() {
    toast.add({
        icon: "i-solar-danger-triangle-bold-duotone",
        title: "مشکلی پیش آمد!",
        description: "خطا در ارسال اطلاعات، لطفا مجدد تلاش نمایید",
        timeout: 5000,
        color: "rose",
    });
}

async function onSubmit(event: FormSubmitEvent<Schema>) {
    if (event.data) {
        loading.value = true;
        fetchData("/comments", {
            method: "POST",
            useSanctum: true,
            body: {
                commentable_type: "App\\Models\\Product",
                commentable_id: route.params.slug,
                parent_id: props.replyTo?.id,
                ...event.data,
            },
            onRequestError() {
                errorSubmit();
                loading.value = false;
            },
            onResponse({ response }) {
                if (isResponseSuccessful(response.status)) showSuccess.value = true;
            },
            onResponseError({ error }) {
                errorSubmit();
            },
        }).then(() => {
            loading.value = false;
        });
    }
}
</script>

<style scoped></style>
